export default [
  {
    url: '/back',
    name: '분야 바로가기',
    icon: 'ArrowLeftIcon',
    activeCode: '',
  },
  {
    url: '/home',
    name: '대시보드',
    icon: '',
    activeCode: '',
  },
  {
    url: '/',
    name: '시스템 계약 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/118/page',
        name: '계약정보',
        icon: 'w-line',
        activeCode: '',
        groupName: ['118'],
      },
    ]
  },
  {
    url: '/',
    name: '신규 시설물 등록 요청',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/303',
        name: '시설물',
        icon: 'w-line',
        activeCode: '',
        groupName: ['303'],
      },
    ]
  },
  {
    url: '/',
    name: '사업장/시설물 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/field/info/type-d',
        name: '시설물 현황',
        icon: 'w-line',
        activeCode: 'field-facility',
      },
    ]
  },
  {
    url: '/',
    name: '안전보건조직체계',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/298',
        name: '관리감독자 선임',
        icon: 'w-line',
        activeCode: '',
        groupName: ['298'],
      },
      {
        url: "/tab/126",
        name: "안전보건 조직 체계도",
        icon: "w-line",
        activeCode: "",
        groupName: ["126"],
      },
      {
        url: '/tab/299',
        name: '종사자 정보',
        icon: 'w-line',
        activeCode: '',
        groupName: ['299'],
      },
      {
        url: '/tab/304',
        name: '유관기관 비상연락망',
        icon: 'w-line',
        activeCode: '',
        groupName: ['304'],
      },
      {
        url: '/tab/319',
        name: '안전보건관리체계 구축 현황(중대시민재해)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['319'],
      },
    ]
  },
  {
    url: '/',
    name: '안전보건관리 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/317',
        name: '중대시민재해 종합계획',
        icon: 'w-line',
        activeCode: '',
        groupName: ['317'],
      },
      {
        url: '/tab/137',
        name: '안전보건 점검 계획',
        icon: 'w-line',
        activeCode: '',
        groupName: ['137'],
      },
      {
        url: '/tab/348',
        name: '중대시민재해 이행사항 점검',
        icon: 'w-line',
        activeCode: '',
        groupName: ['348'],
      },
    ]
  },
  {
    url: '/',
    name: '안전보건 예산',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/_155/page',
        name: '부서별 안전보건 예산(C형)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['155/page'],
      },
      {
        url: '/tab/155',
        name: '안전보건 예산(C형)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['155'],
      },
    ]
  },
  {
    url: '/',
    name: '교육 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/107',
        name: '안전·보건 교육',
        icon: 'w-line',
        activeCode: '',
        groupName: ['107'],
      },
    ]
  },
  {
    url: '/',
    name: '유해·위험요인 관리',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/108',
        name: '유해·위험요인 조사표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['108', '156', '157', '158', '159', '305', '306'],
      },
      {
        url: '/tab/160',
        name: '유해·위험요인 점검(개선)사항 요청',
        icon: 'w-line',
        activeCode: '',
        groupName: ['160'],
      },
    ]
  },
  {
    url: '/',
    name: '위험성평가',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/161',
        name: '정기 위험성평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['161'],
      },
      {
        url: '/tab/162',
        name: '수시 위험성평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['162'],
      },
      {
        url: '/tab/151',
        name: '위험성평가협의회',
        icon: 'w-line',
        activeCode: '',
        groupName: ['151'],
      },
    ]
  },
  {
    url: '/',
    name: '안전보건 점검',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/163',
        name: '일일안전보건점검일지',
        icon: 'w-line',
        activeCode: '',
        groupName: ['163'],
      },
      {
        url: '/tab/100',
        name: '작업장 합동점검',
        icon: 'w-line',
        activeCode: '',
        groupName: ['100'],
      },
      {
        url: '/tab/289',
        name: '[공통]안전보건 순회점검표(사무실)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['289'],
      },
      {
        url: '/tab/291',
        name: '[공통]안전 순회점검표(현장)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['291'],
      },
      {
        url: '/tab/290',
        name: '[공통]보건 순회점검표(현장)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['290'],
      },
      // {
      //   url: '/tab/292',
      //   name: '[공통]근골격계 증상조사표(근로자)',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['292'],
      // },
      // {
      //   url: '/tab/293',
      //   name: '[공통]근골격계부담작업 체크리스트',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['293'],
      // },
      // {
      //   url: '/tab/296',
      //   name: '[공통]동청사 안전점검표',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['296'],
      // },
      // #860pxq0zt
      // {
      //   url: '/tab/166',
      //   name: '냉온수기 및 보일러 설비',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['166'],
      // },
      //
      // #860pxq0zt
      // {
      //   url: '/tab/110',
      //   name: '도로 보수',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['110'],
      // },
      // #860pxq0zt
      // {
      //   url: '/tab/168',
      //   name: '시설물 관리(공통)',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['168'],
      // },
      // #860pxq0zt
      // {
      //   url: '/tab/164',
      //   name: '요양보호사',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['164'],
      // },
      // #860pxq0zt
      // {
      //   url: '/tab/165',
      //   name: '종사자 및 주차시설',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['165'],
      // },
      // #860pxq0zt
      // {
      //   url: '/tab/167',
      //   name: '행사자 동선 및 관계자',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['167'],
      // },
      // {
      //   url: '/',
      //   name: '외 점검표...',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: [''],
      // },


    ]
  },
  {
    url: '/',
    name: '시설물 관리',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/114',
        name: '시설물 점검',
        icon: 'w-line',
        activeCode: '',
        groupName: ['114'],
      },
      {
        url: '/tab/234',
        name: '시설물 진단',
        icon: 'w-line',
        activeCode: '',
        groupName: ['234'],
      },
      {
        url: '/tab/235',
        name: '시설물 보수',
        icon: 'w-line',
        activeCode: '',
        groupName: ['235'],
      },
      {
        url: '/tab/236',
        name: '시설물 보강',
        icon: 'w-line',
        activeCode: '',
        groupName: ['236'],
      },
      {
        url: '/tab/237',
        name: '시설물 교체',
        icon: 'w-line',
        activeCode: '',
        groupName: ['237'],
      },
    ]
  },
  {
    url: '/',
    name: '재해 발생대비 대책',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/116/page',
        name: '(재해발생) 산업재해 발생 시 보고 절차 안내',
        icon: 'w-line',
        activeCode: '',
        groupName: ['116'],
      },
      {
        url: '/tab/238/page',
        name: '(재해발생) 비상조치 및 처리 절차 안내',
        icon: 'w-line',
        activeCode: '',
        groupName: ['238'],
      },
      {
        url: '/tab/239',
        name: '비상대피 훈련·교육·자체평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['239', '240', '241'],
      },
      {
        url: '/tab/242',
        name: '비상조치계획 수립',
        icon: 'w-line',
        activeCode: '',
        groupName: ['242'],
      },
    ]
  },
  {
    url: '/',
    name: '자료실',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/filelibrary/347',
        name: '자료실',
        activeCode: 'filelibrary-347',
        icon: 'w-line'
      },
    ]
  },
  {
    url: '/community',
    name: '커뮤니티',
    slug: 'community',
    icon: '',
    submenu: [
      {
        url: '/community/businessnews',
        name: '기관장 메세지',
        activeCode: 'community_businessnews',
        icon: 'w-line'
      },
      {
        url: '/community/healthinfo',
        name: '안전보건 주요 일정',
        activeCode: 'community_healthinfo',
        icon: 'w-line'
      },
      {
        url: '/community/unitbusinessnews',
        name: '구성원 요청사항',
        activeCode: 'community_unitbusinessnews',
        icon: 'w-line'
      },
      {
        url: '/community/qna',
        name: 'Q&A',
        activeCode: 'community_qna',
        icon: 'w-line'
      }
    ]
  },
  {
    url: '/mypage',
    name: '마이페이지',
    slug: 'safety',
    icon: '',
    submenu: [
      {
        url: '/mypage/workstatus',
        name: '업무현황',
        slug: '',
        icon: 'w-line'
      },
      {
        url: '/mypage/alert',
        name: '알림',
        slug: '',
        icon: 'w-line'
      },
      {
        url: '/',
        name: '결재관리',
        slug: '',
        icon: 'w-line',
        submenu: [
          {
            url: '/approval-request',
            name: '결재요청함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-await',
            name: '결재대기함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-process',
            name: '결재진행함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-complete',
            name: '완료문서함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-reject',
            name: '반려문서함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-reference',
            name: '참조/회람문서함',
            slug: '',
            icon: 'w-line'
          },
        ]
      },
      {
        url: '/',
        name: '설정',
        slug: '',
        icon: 'w-line',
        submenu: [
          {
            url: '/mypage/info-update',
            name: '개인정보변경',
            slug: '',
            icon: 'w-line'
          },
        ]
      }
    ]
  }
]
